import { Component, OnInit } from "@angular/core";
import { MatDialog, MatTableDataSource } from "@angular/material";
import { Router, NavigationStart } from "@angular/router";
import { interval, Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";

import { ConvertUpochToDate } from "src/_helpers/utils";
import { EventDetails, OpenBet } from "src/_models";
import { eventRiskAnalysisReport, MarketRisk } from "src/_models/market_risk";
import { AppService } from "src/_services/app.service";
import { EventService } from "src/_services/event.service";
import { UserBookComponent } from "../user-book/user-book.component";

@Component({
  selector: "app-event-risk",
  templateUrl: "./event-risk.component.html",
  styleUrls: ["../market-risk.component.scss"],
})
export class EventRiskComponent implements OnInit {
  eventInfo: eventRiskAnalysisReport[];
  selectedEvent: EventDetails;
  panelOpenState = false;
  openBets: MatTableDataSource<OpenBet>;
  mySubscription: Subscription;

  eventId: string;
  providerID: string;
  sportId: string;
  eventName: string;

  constructor(
    private appService: AppService,
    private eventService: EventService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.mySubscription.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.eventId = this.route.snapshot.paramMap.get("eventId");
    this.providerID = this.route.snapshot.paramMap.get("providerId");
    this.sportId = this.route.snapshot.paramMap.get("sportId");

    if (this.eventId && this.providerID) this.getEventRiskDetails();
  }

  getEventRiskDetails() {
    if (this.openBets && this.openBets.data) {
      this.mySubscription = interval(10000).subscribe((x) => {
        this.getMarketRisk();
        this.getOpenBets();
      });
    }

    this.getMarketRisk();
    this.getOpenBets();
  }

  // ProviderId, EventId
  getMarketRisk() {
    try {
      this.appService
        .getOperatorRisk(this.providerID, this.sportId, this.eventId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.eventInfo = res.events[0];
          }
        });
    } catch (err) {}
  }

  getOpenBets() {
    try {
      this.eventService
        .eventOpenBets(this.providerID, this.sportId, this.eventId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            // this.openBets = res.openBets;
            this.openBets = new MatTableDataSource(res.openBets);
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              // this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  isHaveOpenBets = (marketId: string) => {
    if (this.openBets && this.openBets.data) {
      for (let op of this.openBets.data) {
        if (op.marketId === marketId) {
          return false;
        }
      }
    }

    return true;
  };

  convertUpochToDate(date: number) {
    return ConvertUpochToDate(date);
  }

  onClickUserRiskHandler(marketId: string) {
    this.dialog.open(UserBookComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        userBookInfo: {
          providerId: this.providerID,
          sportId: this.sportId,
          eventId: this.eventId,
          marketId: marketId,
        },
      },
    });
  }

  onRedirectToBack() {
    this.router.navigateByUrl(`/reports/risk_analysis`);
  }
}
